import { ASSET_TYPE_TO_AI_INPUTS_TYPENAME } from '../constants/assetTypes';
import { getSegment } from './personalizationStrategy/segments';
import { getCrmObjectTarget } from './targeting';
export const getName = typedInputs => typedInputs && 'name' in typedInputs ? typedInputs.name : undefined;
const getAiInputSegment = typedInputs => typedInputs && getSegment(typedInputs);
export const getSegmentType = typedInputs => {
  var _getAiInputSegment;
  return (_getAiInputSegment = getAiInputSegment(typedInputs)) === null || _getAiInputSegment === void 0 ? void 0 : _getAiInputSegment.segmentType;
};
export const getSegmentId = typedInputs => {
  var _getAiInputSegment2;
  return (_getAiInputSegment2 = getAiInputSegment(typedInputs)) === null || _getAiInputSegment2 === void 0 ? void 0 : _getAiInputSegment2.implementationObjectId;
};
export const getAiInputCrmObjectTarget = typedInputs => getCrmObjectTarget(typedInputs === null || typedInputs === void 0 ? void 0 : typedInputs.targetingConfig);
export const createExecutionInputs = inputs => Object.assign({}, inputs, {
  __typename: ASSET_TYPE_TO_AI_INPUTS_TYPENAME[inputs.assetCoordinates.source]
});